const regions = ["Select Region...", "North America", "South America", "Europe, Middle East, Africa", "Asia Pacific"];

const locations = [
  [], 
  ["Select Location...", "US GOM", "US Land", "Alaska", "Canada", "Mexico"],
  ["Select Location...", "Argentina", "Brazil", "Colombia", "Trinidad"],
  ["Select Location...", "Africa", "Norway", "Spain - Las Palmas", "UAE - Dubai", "UK - Aberdeen"],
  ["Select Location...", "Australia", "Malaysia", "Singapore", "Thailand"]
];

const form = $("form.contact-form");
const regionSelect = $("form.contact-form select[name='region']");
const locationSelect = $("form.contact-form select[name='location']");

if (regionSelect) {
  regionSelect.innerHTML = "";
  regions.forEach(function(region) {
      const option = document.createElement("option");
      option.innerText = region;
      option.value = region;
      if (region === "Select Region...") {
        option.value = "";
      }
      regionSelect.append(option);
  });

  regionSelect.addEventListener("change", function() {
      const region = this.value;
      locationSelect.innerHTML = "";
      let index = regions.indexOf(region);
      if (index === -1) {
        index = 0;
      }

      locations[index].forEach(function(loc) {
        const option =  document.createElement("option");
        option.innerText = loc;
        option.value = loc;
        if (loc === "Select Location...") {
          option.value = "";
        }

        locationSelect.append(option);
      });
  });
}

if (form) {
  const thankYouPage = form.querySelector("#thank-you-page").getAttribute("href");

  form.addEventListener("submit", function(event) {
    event.preventDefault();
    const button = form.querySelector("button[type='submit']");
    button.disabled = true;

    const formData = new FormData(form);
    const jsonData = {};
    formData.forEach((value, key) => {
      jsonData[key] = value;
    });

    fetch(form.action, {
      method: form.method,
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(jsonData)
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        button.disabled = false;
        window.location.href = thankYouPage;
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  });
}